import type { IconSvgObject } from './types';

const Backward02Icon: IconSvgObject = [
  ["path", { d: "M11.6281 17.0794V6.92068C11.6281 6.11166 10.7174 5.63751 10.0546 6.10145L2.79842 11.1808C2.22971 11.5789 2.22971 12.4212 2.79843 12.8193L10.0546 17.8986C10.7174 18.3625 11.6281 17.8884 11.6281 17.0794Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.6281 17.0794V6.92068C21.6281 6.11166 20.7174 5.63751 20.0546 6.10145L12.7984 11.1808C12.2297 11.5789 12.2297 12.4212 12.7984 12.8193L20.0546 17.8986C20.7174 18.3625 21.6281 17.8884 21.6281 17.0794Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Backward02Icon;
